import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import MainLayout from "../../components/layout/MainLayout";
import Breadcrumbs from "../../components/common/Breadcrumbs";
import SessionTypeForm from "./SessionTypeForm";
import { fetchSessionMaster, updateSessionMaster } from "../../store/slices/sessionSlice";
import { fetchSessionCategories } from "../../store/slices/sessionCategorySlice";

const EditSessionType = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { currentSessionMaster, isLoading, error } = useSelector(
        (state) => state.sessions
    );
    const { sessionCategories } = useSelector(
        (state) => state.sessionCategories
    );

    const [formData, setFormData] = useState({
        session_category_master_id: "",
        name: "",
        description: "",
        status: "active",
    });

    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (id) {
            dispatch(fetchSessionMaster(id));
            dispatch(fetchSessionCategories());
        }
    }, [dispatch, id]);

    useEffect(() => {
        if (currentSessionMaster && Object.keys(currentSessionMaster).length > 0) {
            setFormData({
                session_category_master_id: currentSessionMaster.session_category_master_id || "",
                name: currentSessionMaster.name || "",
                description: currentSessionMaster.description || "",
                status: currentSessionMaster.status || "active",
            });
        }
    }, [currentSessionMaster]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.session_category_master_id) newErrors.session_category_master_id = "Category is required";
        if (!formData.name.trim()) newErrors.name = "Name is required";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            Swal.fire({
                title: "Missing Fields",
                text: "Please fill all required fields.",
                icon: "warning",
                confirmButtonText: "OK",
            });
            return;
        }

        try {
            await dispatch(updateSessionMaster({ id, formData })).unwrap();

            Swal.fire({
                title: "Success!",
                text: "Session Type updated successfully.",
                icon: "success",
                timer: 2000,
                showConfirmButton: false,
            });

            navigate("/session-types");
        } catch (err) {
            Swal.fire({
                title: "Error",
                text: err.message || "Failed to update Session Type",
                icon: "error",
                confirmButtonText: "OK",
            });
        }
    };

    if (isLoading) return <div className="p-3">Loading...</div>;
    if (error) return <div className="p-3 text-danger">{error}</div>;

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />
                <div className="card">
                    <div className="card-body">
                        {Object.keys(errors).length > 0 && (
                            <div className="alert alert-danger">
                                {Object.values(errors).map((err, i) => (
                                    <div key={i}>{err}</div>
                                ))}
                            </div>
                        )}

                        <form onSubmit={handleSubmit}>
                            <SessionTypeForm
                                formData={formData}
                                handleChange={handleChange}
                                categories={sessionCategories}
                            />

                            <div className="row mt-3">
                                <div className="col-md-2 ms-auto">
                                    <button type="submit" className="btn btn-primary w-100">
                                        <i className="ri-edit-2-line me-1"></i> Update
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default EditSessionType;
